import { GradeClassMarkApi, GradeClassMarkStudentApi, Student } from '@/plugins/api'
import get from 'lodash-es/get'
const namespaced = true

const getDisplayedMarks = (marks = []) => {
  let groups = marks.filter((x) => x.isGroup)
  const nonGroups = marks.filter((x) => !x.isGroup && !x.parent)
  if (Array.isArray(groups) && groups.length) {
    groups = groups.map((g) => ({ ...g, children: marks.filter((m) => m.parent === g.id) }))
  }
  return [...groups, ...nonGroups].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
}

const getDisplayedMarksForReport = (marks = []) => {
  const sortedMarks = [...marks].map((x, index) => ({ ...x, index }))
  const groups = sortedMarks
    .filter((x) => x.isGroup)
    .map((x) => ({ ...x, maxColum: sortedMarks.filter((m) => m.parent === x.id).length }))
  const singles = sortedMarks.filter((x) => !x.isGroup)
  let headers = []
  if (groups.length)
    headers = sortedMarks
      .map((x) => {
        if (x.isGroup) return { ...x, maxCol: sortedMarks.filter((m) => m.parent === x.id).length }
        if (!x.parent) return { ...x, maxCol: 1 }
        return null
      })
      .filter(Boolean)
  else headers = singles.map((x) => ({ ...x, maxCol: 1 }))
  return { groups, singles, headers }
}

const state = {
  marks: [],
  studentMarksOrderByGrade: [],
  countStudentMarksOrderByGrade: 0,
}

const actions = {
  async fetchAll({ commit }, params) {
    const res = await GradeClassMarkApi.fetch(params)
    commit('setMarks', res)
  },
  async update(_, { id, ...body }) {
    await GradeClassMarkApi.update(id, body)
  },
  async fetchReport(_, gradeClass) {
    const gradeMarks = await GradeClassMarkApi.fetch({ gradeClass, _sort: 'createdAt:asc' })
    const { groups, singles, headers } = getDisplayedMarksForReport(gradeMarks)
    const students = await Student.fetch({ classes: gradeClass, _sort: 'nameToNumber:asc' })
    const studentMarks = await GradeClassMarkStudentApi.fetch({ gradeClass })
    const studentWithMark = students.map((student) => {
      let marks = singles.map((item) => {
        const ext = studentMarks.find(
          (x) => get(x, 'gradeClassMark.id') === item.id && get(x, 'student.id') === student.id
        )
        if (ext) return { id: ext.id, score: ext.score, updatedAt: ext.updatedAt, type: item.type, factor: item.factor }
        return { type: item.type, factor: item.factor, score: '-' }
      })
      if (marks.filter((x) => !x.id).length) {
        marks.push({ score: '-' })
      } else {
        marks.push({
          score: marks
            .map((x) => Number(x.factor) * Number(x.score))
            .reduce((a, c) => a + c, 0)
            .toFixed(2),
          type: 'total',
        })
      }
      return { student, marks }
    })
    return { groups, singles, studentWithMark, headers }
  },
  async fetchReportForStudent(_, { studentId, gradeClass }) {
    const student = await Student.fetchOne(studentId)
    if (student) {
      const gradeMarks = await GradeClassMarkApi.fetch({ gradeClass, _sort: 'createdAt:asc' })
      const { groups, singles, headers } = getDisplayedMarksForReport(gradeMarks)
      const studentMarks = await GradeClassMarkStudentApi.fetch({ gradeClass, student: studentId })
      const studentWithMark = [student].map((student) => {
        let marks = singles.map((item) => {
          const ext = studentMarks.find((x) => get(x, 'gradeClassMark.id') === item.id)
          if (ext)
            return { id: ext.id, score: ext.score, updatedAt: ext.updatedAt, type: item.type, factor: item.factor }
          return { type: item.type, factor: item.factor, score: '-' }
        })
        if (marks.filter((x) => !x.id).length) {
          marks.push({ score: '-' })
        } else {
          marks.push({
            score: marks
              .map((x) => Number(x.factor) * Number(x.score))
              .reduce((a, c) => a + c, 0)
              .toFixed(2),
            type: 'total',
          })
        }
        return { student, marks }
      })
      return { groups, singles, studentWithMark, headers }
    }
    return { noData: true }
  },
  async getStudentMarks({ commit }, params) {
    const res = await GradeClassMarkStudentApi.getStudentMarks(params)
    commit('setStudentMarkOrderByGrade', res)
    return res
  },
  async countStudentMarks({ commit }, params) {
    const res = await GradeClassMarkStudentApi.countStudentMarks(params)
    commit('setCountStudentMarksOrderByGrade', res)
    return res
  },
}

const mutations = {
  setMarks(state, marks) {
    state.marks = marks
  },
  setStudentMarkOrderByGrade(state, marks) {
    state.studentMarksOrderByGrade = marks
  },
  setCountStudentMarksOrderByGrade(state, marks) {
    state.countStudentMarksOrderByGrade = marks
  },
}

const getters = {
  getDisplayedMarks: (state) => {
    return getDisplayedMarks(state.marks)
  },
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters,
}
